
import * as loginActions from "../../containers/login/LoginActions";

const HTTP_STATUS_UNAUTHORIZED = 401;
export default store => next => action => {
    if (action.payload && action.error && action.payload.response && action.payload.response.status === HTTP_STATUS_UNAUTHORIZED){
        store.dispatch(loginActions.sessionExpired())
    }
    return next(action)
};



// WEBPACK FOOTER //
// ./src/redux/middlewares/Firewall.js